module.exports = __webpack_public_path__ + "static/media/gix-logo.66635ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/gix-logo.png
// module id = 943
// module chunks = 0